// extracted by mini-css-extract-plugin
export default {"login_form":"Login_login_form__ZXmjt","label":"Login_label__YlHPF","form_control":"Login_form_control__Qs86z","btn":"Login_btn__mxqsC"};